import { emit } from '@zapier/events-toolkit-browser';

const UserInteractionEvent =
  'web_analytics.tracking.user_interaction.UserInteractionEvent';

export type EventDetails = {
  interaction_name?: 'call_to_action';
  event_action: string;
  option_selected?: string;
};

export const emitUserInteractionEvent = async ({
  interaction_name = 'call_to_action',
  ...eventDetails
}: EventDetails) => {
  return await emit(
    {
      ...eventDetails,
      absolute_url: window.location.pathname,
      interaction_name,
      referrer: document.referrer,
      system_name: 'design_system',
    },
    UserInteractionEvent
  );
};
